<nz-header class="section-header">
  {{ "Physiotherapy" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.bergBalanceScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="8"
      [historyItems]="getTemplateItems(8)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.patientAssessmentCard) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="9"
      [historyItems]="getTemplateItems(9)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.slagQuestionnaire) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="11"
      [historyItems]="getTemplateItems(11)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.sldcQuestionnaire) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="10"
      [historyItems]="getTemplateItems(10)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
